export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: 'createdAt',
    label: 'label.no',
  },
  {
    key: 'chatChannelName',
    sortable: false,
    label: 'field.chatChannelName',
    class: 'break-spaces',
  },
  {
    key: 'conversation',
    sortable: false,
    label: 'field.conversation',
  },
  {
    key: 'approvedToRag',
    sortable: false,
    label: 'field.status',
    class: 'text-center',
  },
  {
    key: 'fullConversation',
    sortable: false,
    label: 'field.fullConversation',
  },
  {
    key: 'topics',
    sortable: false,
    label: 'field.topics',
  },
  {
    key: 'startTime',
    sortable: false,
    label: 'field.startTime',
  },
  {
    key: 'endTime',
    sortable: false,
    label: 'field.endTime',
  },
  {
    key: 'createdAt',
    sortable: false,
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
